// extracted by mini-css-extract-plugin
export var box = "_5m-0";
export var check = "_5m-1";
export var checkboxButton = "_5m-6";
export var checkboxGroup = "_5m-5";
export var disabled = "_5m-7";
export var ghost = "_5m-9";
export var input = "_5m-2";
export var label = "_5m-4";
export var normal = "_5m-8";
export var uncheck = "_5m-3";